function playVimeoVideo(vimeoVideoId) {
}

function playYouTubeVideo(youtubeVideoId, beforePlayCallback, onExitCallback) {
}

export default {
    playVimeoVideo,
    playYouTubeVideo,
}